<template>
    <div>
        <privacy v-if="authed"></privacy>
        <upload-progress></upload-progress>
        {{isAuthed}}
        <div class="nav-wrapper" v-show="$route.query.expanded!=true">
            <nav class="navbar" v-if="authed">

                <router-link 
                    v-if="(roles.includes('Student') && terms.length > 3) || roles.includes('Mentor')" 
                    to="/mentor-dashboard"                    
                    class="navbar-brand">
                    <img src="../assets/img/logo.png" alt="TTTO">
                </router-link>
                <a v-else class="navbar-brand" href="/">
                    <img src="../assets/img/logo.png" alt="TTTO">
                </a>
                <div class="navbar-wrapper">
                    <ul class="nav navbar-nav">

                        <li v-if="!roles.includes('LiteStudent')">
                            <router-link :to="{ name: 'forum-category', params: { categorySlug: 'job-board'} }" class="nav-item nav-link">Job Board</router-link>
                        </li>

                        <li v-if="roles.includes('Supervisor') || roles.includes('OnlineDirector') || roles.includes('CampusDirector') || roles.includes('LessonAuditor') || roles.includes('CourseAdmin')">
                            <router-link to="/dashboard" class="nav-item nav-link">Course Admin</router-link>
                        </li>

                        <li v-if="roles.includes('Supervisor')">
                            <router-link to="/weekly-updates" class="nav-item nav-link">Weekly Updates</router-link>
                        </li>

                        <li v-if="roles.includes('Faculty') || roles.includes('Supervisor') || roles.includes('OnlineDirector')">
                            <router-link :to="{name: 'inbox', query: { tab: 'inbox'} }" class="nav-item nav-link"><span class="unread badge" v-if="unread > 0">{{unread}}</span>Inbox</router-link>
                        </li>

                        <li v-if="(roles.includes('Student') && terms.length > 3) || roles.includes('CampusStudent') || roles.includes('Mentor')">
                            <router-link v-if="!roles.includes('LiteStudent')" to="/checkins" class="nav-item nav-link">Check-Ins</router-link>
                        </li>

                        <li v-if="roles.includes('Student')">
                            <router-link to="/journey" class="nav-item nav-link">My Journey</router-link>
                        </li>

                        <li v-if="roles.includes('Student')">
                            <router-link :to="{ name: 'status' }" class="nav-item nav-link">My Status</router-link>
                        </li>

       <!--                  <li v-if="roles.includes('Student')">
                            <router-link to="/invoices" class="nav-item nav-link">My Tuition</router-link>
                        </li> -->

                        <li v-if="roles.includes('Student')">
                            <router-link to="/weekly-updates" class="nav-item nav-link">Weekly Updates</router-link>
                        </li>

                        <li v-if="isNotRecruiter">
                            <router-link :to="{ name: 'mentorSelector'}" class="nav-item nav-link">Mentors</router-link>
                        </li>

                        <li v-if="connectionAllowed || roles.includes('Mentor')">
                            <router-link :to="{ name: 'mentorConnections'}" class="nav-item nav-link">Connections</router-link>
                        </li>

                        <li v-if="!roles.includes('Faculty') && roles.includes('Admin') || roles.includes('Support')">
                            <router-link :to="{ name: 'inbox', query: { tab: 'inbox'} }" class="nav-item nav-link"><span class="unread badge" v-if="unread > 0">{{unread}}</span>Inbox</router-link>
                        </li>

                        <li v-if="roles.includes('GlobalMentor')">
                            <router-link to="/meetings" class="nav-item nav-link">Calendar</router-link>
                        </li>

                        
                    </ul>
                    <search v-if="roles.includes('Student')" />
                    <bulletins v-if="authed"></bulletins>
                    <img v-if="$store.state.person" :src="$store.state.person.avatar || 'https://ttto-avatars.s3-us-west-2.amazonaws.com/avatar-placeholder.jpg'" class="avatar" @click="accountDropdown = !accountDropdown">
                    <div class="accountDropdown" v-show="accountDropdown">
                        <router-link to="/settings" class="nav-item nav-link"><div>Account Settings</div></router-link>
                        <a @click.prevent="logout" class="nav-item nav-link"><div>Log out</div></a>
                    </div>
                    <div class="dropdownOutside" v-if="accountDropdown" @click="accountDropdown = false"></div>
                    <i @click="toggleMobileMenu()" class="mobile-menu-button fa fa-navicon"></i>
                </div>

            </nav>
        </div>
    </div>
</template>
<script>
import auth from '../services/auth';
import oauth from '../services/oauth';
import chat from '../services/chat';
import Bulletins from '../components/widgets/Bulletins';

import uploadProgress from './reusable/upload-progress/UploadProgress';
import Privacy from './widgets/Privacy.vue';
import users from '../services/users';
import Search from './widgets/Search.vue';

export default {
    data() {
        return {
            authed: false,
            accountDropdown: false,
        }
    },
    mounted() {
        var self = this;

        this.$store.dispatch('toggle', { type: 'loading', boolean: false });
        self.$bus.$on('login', function() {
            self.authed = true;
        });

        function getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (decodeURIComponent(pair[0]) == variable) {
                    return decodeURIComponent(pair[1]);
                }
            }
            console.log('Query variable %s not found', variable);
        }

        if (window.location.href.indexOf('redirect_uri') > -1) {
            this.$route.query.client_id = getQueryVariable('client_id');
            this.$route.query.redirect_uri = getQueryVariable('redirect_uri');
            this.authorizeVersapay();
        }

        if (localStorage.user_id) {
            users.getMe().then((response) => {
                this.$store.state.person = response.data.person;
            });
        }
    },
    components: {
        'upload-progress': uploadProgress,
        Privacy,
        Bulletins,
        Search
    },
    methods: {

        toggleMobileMenu() {
            this.$bus.$emit('toggleMobileMenu');
        },
        authorizeVersapay() {
            var redirect_uri = this.$route.query.redirect_uri || 'https://secure.versapay.com/auth/thinktank/callback';
            var data = {
                client_id: this.$route.query.client_id || '66383dea-67f9-447a-af69-4bf93100c6ce',
                redirect_uri: redirect_uri,
                user: localStorage.account_id
            }
            oauth.getCode(this, data).then(function(response) {
                window.location = redirect_uri + '?code=' + response.data.authorizationCode;
            });
        },

        logout() {
            var self = this;
            if (window.location.host === 'portal.tttc.ca')  {
                chat.rocketLogout();
            }
            auth.logout(this).then(function(response) {

            });

            self.$bus.$emit('logout');
            self.$socket.emit('deauthorized', localStorage.user_id);
            self.authed = false;

            const preservedSettings = ['preferred_resolution','preferred_speed','preferred_video_volume','selectedCourseSets'];

            Object.keys(localStorage).forEach((key)=> {
                if (!preservedSettings.includes(key)) {
                    localStorage.removeItem(key);
                }
            });

            if (!localStorage.getItem('selectedCourseSets') || localStorage.getItem('selectedCourseSets') === 'undefined') {
                localStorage.setItem('selectedCourseSets','{}');
            }

            window.location.reload();

            self.$router.push('/');

        },
    },
    computed: {
        isNotRecruiter() {
            const roles = JSON.parse(localStorage.getItem('roles'));
            return roles.length > 1 || !roles.includes('Recruiter');
        },
        isDev() {
            return window.location.hostname == 'dev-portal.tttc.ca' || window.location.hostname == 'localhost'
        },
        roles() {
            return JSON.parse(localStorage.getItem('roles'));
        },
        terms() {
            return (localStorage.getItem('terms').split(','));
        },
        unread() {
            return this.$store.state.unreadMessages
        },
        isAuthed() {
            localStorage.getItem('account_id') ? this.authed = true : this.authed = false;
        },
        connectionAllowed() {
            const settings = this.$store.getters.settings;
            let allowed = false;

            if (settings && settings.length > 0) {
                let overrides = settings.find((s)=>{return s.name=== 'mentorSelectorOverride'}).data;
                const overridden = overrides.includes(parseInt(localStorage.user_id));
                let studentGroups = localStorage.group.split(',');
                let inCampusMentorshipGroup = (studentGroups.includes('21'));
                if (overridden === true || localStorage.terms.split(',').length === 3 || (localStorage.roles.includes('CampusStudent') && inCampusMentorshipGroup)) {
                    allowed = true;
                }
            }
            return allowed;
        },
        loading() {
            return this.$store.getters.loading;
        },
        userId() {
            return localStorage.getItem('user_id');
        },

    }
}

</script>
<style lang="scss" scoped>
.search {
    font-size:2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 19.5px;
    padding-bottom: 19.5px;
    padding-left:1rem;
    padding-right:1rem;
    i {
        cursor: pointer;
    }
}

a {
    cursor: pointer;
}

.logout {
    padding-left:12px;
}

.avatar {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    margin-left: 1.5rem;
    cursor: pointer;
    z-index: 9999;
    object-fit: cover;
}

.accountDropdown {
    position: absolute;
    top: 59px;
//   right: 34px;
    background: #222222;
    font-size: 9pt;
    color: lightgray;
    border: #444444 solid 1px;
    padding: 1rem;
    z-index: 9999998;
    // border-radius: 10px;

    a {
        text-decoration: none;
    }
    div {
        background: transparent;
        cursor: pointer;
        // border-radius: 5px;
        padding: 1rem;

        &:hover {
            color: white;
            background: #d3d3d34b;
        }
    }
}

.dropdownOutside {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: transparent;
  z-index: 9997;
  top: 0;
  right: 0;
}

.navbar-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-left: auto;
    margin-right: 2rem;
}
.mobile-menu-button {
    color: #fff;
    font-size: 2rem;
    float: right;
    position: absolute;
    right: 4rem;
    top: 5rem;
    z-index: 999999999;
    cursor: pointer;
    display: none;
    //   @media screen and (max-width: 1023px) {
    //     display:block
    // }
}

/*@media screen and (max-width:1599px) {
      .navbar {padding:0 5px 20px 0;}
      }*/

.navbar-brand {
    
    margin-left: 30px;
    margin-top: 4px;
    padding: 0;
    transform: translate(15px, 11px);
}


.navbar-brand img {
    max-height: 41px;
    width: auto;
}

.student-name {
    padding: 2rem;
    font-weight: 700;
}


.nav-wrapper {
    background: #000;
}

.navbar {
    max-width: 1366px;
    float: none;
    margin: 0 auto;
    display: flex;
}

.navbar a {
    color: #fff;
    text-transform: uppercase;
}

.unread {
    background: red;
    position: relative;
    top: -1px;
    right: 5px;
}

.router-link-exact-active {
    color: #33ccff !important;
    background-color: #363636 !important;
}

.nav > li > a {
    padding:10px!important;
}
</style>
<style lang="scss">
.overlay .v-spinner .v-ring {
    width: 150px !important;
    height: 150px !important;
}

.greeting {
    text-align: center;
}

.overlay .v-spinner {
    .v-ring2 {
        border: 8px solid #33ccff !important;
        opacity: 0.4 !important;
    }

    .v-ring3 {
        border: 8px solid #33ccff !important;
        opacity: .6 !important;
    }
}

</style>



// WEBPACK FOOTER //
// Navbar.vue?f48839d2